import { apiHandler } from "api";
import { endpoint } from "../../../api/endpoint";
import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const PinModal = ({ setPinStatus, setValidatePin }) => {
  const [showPinModal, setShowPinModal] = useState(() => {
    return sessionStorage.getItem("pinModalShown") !== "true";
  });
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handlePinSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError("");
      const response = await apiHandler({
        url: endpoint.VALIDATE_PIN,
        method: "POST",
        data: { sPin: pin },
      });
      if (response?.data?.data?.exists) {
        setPinStatus(false);
        sessionStorage.setItem("pinStatus", "false");
        sessionStorage.setItem("pinModalShown", "true");
        setShowPinModal(false);
        sessionStorage.setItem("pin", pin);
        setValidatePin(pin);
      } else {
        setError("Invalid PIN. Please try again.");
      }
    } catch (error) {
      console.error("Error validating PIN:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setPin(value);
      if (error) setError("");
    }
  };

  return (
    <Modal show={showPinModal} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Enter Access PIN</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handlePinSubmit}>
          <Form.Group controlId="formPin">
            <Form.Label>PIN</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter 4-digit PIN"
              value={pin}
              onChange={handleChange}
              maxLength={4}
              autoFocus
              inputMode="numeric"
              pattern="\d*"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="secondary" onClick={handleSkipPin}>
          Skip
        </Button> */}
        <Button
          variant="primary"
          onClick={handlePinSubmit}
          disabled={pin.length !== 4 || loading}
        >
          {loading ? "Validating..." : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PinModal;
